// extracted by mini-css-extract-plugin
module.exports = {"Painel":"Painel_Painel__2lf9K","content":"Painel_content__27i-c","table":"Painel_table__21u4C","bodyTable":"Painel_bodyTable__3bfAC"};